import { render, staticRenderFns } from "./lostpass.vue?vue&type=template&id=502640e3&scoped=true&"
import script from "./lostpass.vue?vue&type=script&lang=js&"
export * from "./lostpass.vue?vue&type=script&lang=js&"
import style0 from "./lostpass.vue?vue&type=style&index=0&id=502640e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502640e3",
  null
  
)

export default component.exports